export const paperSizeOptions = [
  {
    label: "A5 Portrait",
    value: "A5_portrait",
    lengthInMM: 210,
    widthInMM: 148,
  },
  {
    label: "A5 Landscape",
    value: "A5_landscape",
    lengthInMM: 148,
    widthInMM: 210,
  },
  {
    label: "A4 Portrait",
    value: "A4_portrait",
    lengthInMM: 297,
    widthInMM: 210,
  },
  {
    label: "A4 Landscape",
    value: "A4_landscape",
    lengthInMM: 210,
    widthInMM: 297,
  },
];
